import { Link, Box } from 'front-end/src/components'
import { usePublicApiSession } from 'front-end/src/public-api/hooks/usePublicApiSession'
import React, { FC } from 'react'
import { Redirect, useParams } from 'react-router-dom'
import { t, Trans } from '@lingui/macro'
import { staticLinks } from 'shared/linkBuilder'
import HeadTitle from '../../../components/common/head/HeadTitle'
import { notification } from '../../../components/common/notifications/Notifications'
import {
  useHowUserCanResetPasswordQuery,
  useOrganisationJustIdQuery
} from './ResetPassword.codegen'
import { ResetPasswordViaEmailRequestForm } from 'front-end/src/pages/auth/reset-password/ResetPasswordViaEmailRequestForm'
import { ResetPasswordStrategyEnum } from 'front-end/src/graphql/public/PublicSchemaTypes'
import { ResetPasswordViaSecurityQuestions } from 'front-end/src/pages/auth/reset-password/ResetPasswordViaSecurityQuestions'
import { brandColors } from 'shared/basicPalette'

const ResetPassword: FC = () => {
  const { userIdentity } = useParams<{ userIdentity?: string }>()
  const { session } = usePublicApiSession()

  const { data: strategyData } = useHowUserCanResetPasswordQuery({
    variables: {
      accountNameOrEmail: userIdentity
    },
    skip: !userIdentity
  })

  const { data, loading: loadingOrganisation } = useOrganisationJustIdQuery({
    fetchPolicy: 'cache-first'
  })

  if (!data || loadingOrganisation) {
    return null
  }

  const { organisation } = data

  if (!organisation) {
    notification.error(t`Unknown organisation`)
    return null
  }

  if (session) {
    return <Redirect to={staticLinks.home} />
  }

  return (
    <Box className="Auth">
      <HeadTitle title="Reset password" />
      <Box className="Auth__container">
        {strategyData?.howUserCanResetPassword.strategy ===
          ResetPasswordStrategyEnum.security_questions && userIdentity ? (
          <ResetPasswordViaSecurityQuestions accountName={userIdentity} />
        ) : (
          <ResetPasswordViaEmailRequestForm organisationId={organisation.id} />
        )}

        <Box mt="32px" textAlign="center">
          <Link to={staticLinks.login} color={brandColors.grey['700']}>
            <Trans>Cancel</Trans>
          </Link>
        </Box>
      </Box>
    </Box>
  )
}

export default ResetPassword
